import { ETooltipIntents } from '@src/typings';
import { cva } from 'class-variance-authority';

export const TooltipVariants = cva(
    'w-6 h-6 rounded-lg flex items-center justify-center cursor-pointer text-base',
    {
        variants: {
            intent: {
                [ETooltipIntents.Info]: '',
                [ETooltipIntents.Question]: '',
            },
            color: {
                primary: '',
                secondary: '',
            },
        },
        defaultVariants: {
            intent: ETooltipIntents.Info,
            color: 'primary',
        },
    }
);
